export const formItemLayout724 = {
    labelCol: { span: 7 },
    wrapperCol: { span: 17 },
};

export const formItemLayout024 = {
    labelCol: { span: 0 },
    wrapperCol: { span: 24 },
};
